import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import './Text.css'; 

export const Text = ({ 
  content = '', 
  color = 'var(--text-primary-color)', 
  fontSize = '16px', 
  textAlign = 'center', 
  fontWeight = 'normal', 
  fontStyle = 'normal', 
  backgroundColor = 'transparent', 
  borderColor = 'transparent', 
  borderWidth = '1px', 
  borderStyle = 'solid', 
  borderRadius = '4px',
  fontFamily = '',
  width = "",
  height = "auto",
  lineHeight = "auto",
  overflow= "hidden",
  maxWidth="",
  textOverflow="ellipsis",
  whiteSpace="",
  wordBreak='break-word',
  lineClamp = 2
  
}) => {
  const baseStyles = { 
    color, 
    fontSize, 
    textAlign, 
    fontWeight, 
    fontStyle, 
    backgroundColor,
    borderColor, 
    borderWidth, 
    borderStyle,
    borderRadius,
    fontFamily,
    width,
    height,
    lineHeight,
    overflow,
    maxWidth,
    textOverflow,
    whiteSpace,
    wordBreak
  };

  // Add line clamp styles if lineClamp is specified
  if (lineClamp && lineClamp > 0) {
    baseStyles.display = '-webkit-box';
    baseStyles['-webkit-line-clamp'] = lineClamp.toString();
    baseStyles['-webkit-box-orient'] = 'vertical';
    baseStyles.whiteSpace = 'normal';
  }

  return html`
    <div
      class="storybook-text"
      style=${styleMap(baseStyles)}
    >
      ${content}
    </div>
  `;
};

